import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { applicationOptions } from '../../stores/applications/selectors';
import { groupOptions } from '../../stores/groups/selectors';
import { serverOptions } from '../../stores/servers/selectors';
import { RootState } from '../../stores/store';
import { selectAll, unselectAll, setFilter } from '../../stores/tables/actionCreators';
import { userOptions } from '../../stores/users/selectors';
import { workspaceOptions } from '../../stores/workspaces/selectors';
import TableColumn from '../table/TableColumn';
import TableFilterableColumn from '../table/TableFilterableColumn';
import TableHead from '../table/TableHead';
import TableSelectionColumn from '../table/TableSelectionColumn';
import TableSortableColumn from '../table/TableSortableColumn';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip, UncontrolledTooltip } from 'reactstrap';
import Dropdown from 'react-bootstrap/Dropdown';
import { getFilter } from '../../stores/tables/selectors';
import { TableFilter } from '../../stores/tables/state';
import {getApplicationsId} from '../../repositories/ApplicationRepository';
import {getSearch,getFilters} from '../../stores/tables/selectors';
import { TableFilters } from '../../stores/tables/state';

interface Props extends LocalizeContextProps {
    refresh: () => void;
    ids: string[];
    search: string;
    filters :TableFilters;
    selectAll: (ids: string[]) => void;
    unselectAll: (ids: string[]) => void;
    setTpStatusFilter: (selection: string[]) => void;
    applicationOptions: Array<{ label: string, value: string }>;
    userOptions: Array<{ label: string, value: string }>;
    serverOptions: Array<{ label: string, value: string }>;
    workspaceOptions: Array<{ label: string, value: string }>;
    tpStatusFilter: TableFilter;
}

class ApplicationsTableHead extends React.Component<Props> {
    componentDidMount() {
        this.props.setTpStatusFilter([]);
    }

    public render() {
        const t = this.props.translate;
        return (
            <TableHead>
                <UncontrolledTooltip target="server-icon" placement="right">
                    Task Processor status
                </UncontrolledTooltip>
                <UncontrolledTooltip target="tasks-icon" placement="bottom">
                    Tasks queued
                </UncontrolledTooltip>
                <TableSelectionColumn
                    itemIds={this.props.ids}
                    tableKey="applications"
                    selectAll={() => this.getSelectAppId()}
                    deselectAll={() => this.getunSelectAppId()}
                />
                <TableColumn id="server-icon" className="icon-th" style={{ padding:'0px' }}>
                    <Dropdown onToggle={(isOpen: boolean) => {
                        if (!isOpen && this.tpFilterChanged) {
                            this.props.refresh();
                            this.tpFilterChanged = false;
                        }
                    }}>
                        <Dropdown.Toggle id="server-dropdown">
                            <FontAwesomeIcon icon={['fal', 'server']} />
                        </Dropdown.Toggle>
                        <Dropdown.Menu id="server-dropdown-menu" style={{ padding:'0px' }}>
                            <FontAwesomeIcon size="2x"
                                className={this.props.tpStatusFilter?.includes("Active") ? "text-success server-dropdown-button active" : "text-success server-dropdown-button"}
                                icon={["fal", "sync"]} onClick={() => this.ToggleTpFilter("Active")} />
                            <FontAwesomeIcon size="2x"
                                className={this.props.tpStatusFilter?.includes("Suspended") ? "text-secondary server-dropdown-button active" : "text-secondary server-dropdown-button"}
                                icon={["fal", "pause-circle"]} onClick={() => this.ToggleTpFilter("Suspended")} />
                            <FontAwesomeIcon size="2x"
                                className={this.props.tpStatusFilter?.includes("Error") ? "text-danger server-dropdown-button active" : "text-danger server-dropdown-button"}
                                icon={["fal", "exclamation-circle"]} onClick={() => this.ToggleTpFilter("Error")} />
                            <FontAwesomeIcon size="2x"
                                className={this.props.tpStatusFilter?.includes("Idle") ? "text-primary server-dropdown-button active" : "text-primary server-dropdown-button"}
                                icon={["fal", "check-circle"]} onClick={() => this.ToggleTpFilter("Idle")} />
                            <FontAwesomeIcon size="2x"
                                className={this.props.tpStatusFilter?.includes("") ? "text-muted server-dropdown-button active" : "text-muted server-dropdown-button"}
                                icon={["fal", "question-circle"]} onClick={() => this.ToggleTpFilter("")} />
                        </Dropdown.Menu>
                    </Dropdown>
                </TableColumn>
                <TableColumn id="tasks-icon" className="icon-th">
                    <FontAwesomeIcon icon={['fal', 'tasks']} />
                </TableColumn>
                <TableColumn className="icon-btn-th" />
                <TableSortableColumn
                    tableKey="applications"
                    column="title"
                    refresh={this.props.refresh}
                >
                    {t('applications.table.header.title')}
                </TableSortableColumn>
                <TableSortableColumn
                    tableKey="applications"
                    column="location_path"
                    refresh={this.props.refresh}
                >
                    {t('applications.table.header.location')}
                </TableSortableColumn>
                <TableFilterableColumn
                    tableKey="applications"
                    columnName={t('applications.table.header.server') as string}
                    filterKey="s"
                    options={this.props.serverOptions}
                    refresh={this.props.refresh}
                />
                <TableColumn>
                    {t('applications.table.header.server_alias') as string}
                </TableColumn>
                <TableColumn>
                    {t('applications.table.header.color') as string}
                </TableColumn>            
                <TableFilterableColumn
                    tableKey="applications"
                    columnName={t('applications.table.header.users') as string}
                    filterKey="u"
                    options={this.props.userOptions}
                    refresh={this.props.refresh}
                />
                <TableFilterableColumn
                    tableKey="applications"
                    columnName={t('applications.table.header.workspace') as string}
                    filterKey="w"
                    options={this.props.workspaceOptions}
                    refresh={this.props.refresh}
                />
                <TableColumn className="icon-btn-th" />
                <TableColumn className="icon-btn-th" />
                <TableColumn className="icon-btn-th" />
            </TableHead>
        );
    }

    private getSelectAppId():  void
{   
    
    getApplicationsId(this.props.search,this.props.filters).then
     ( 
      (ids) =>
        this.props.selectAll(ids)   
     );    
    
}
private getunSelectAppId():  void
{   
    getApplicationsId(this.props.search,this.props.filters).then
     (
      (ids) =>
        this.props.unselectAll(ids)   
     );        
}


    private tpFilterChanged: boolean = false;
    private ToggleTpFilter = (status: string) => {
        this.tpFilterChanged = true;
        let newFilter = this.props.tpStatusFilter ?? [];
        if (newFilter?.includes(status)) {
            const index = newFilter.indexOf(status);
            if (index > -1) {
                newFilter.splice(index, 1);
            }
        } else {
            newFilter.push(status);
        }
        this.props.setTpStatusFilter(newFilter);
    }
}

const mapStateToProps = (state: RootState) => ({
    applicationOptions: applicationOptions(state),
    serverOptions: serverOptions(state),
    userOptions: userOptions(state),
    workspaceOptions: workspaceOptions(state),
    search: getSearch(state, 'applications'),
    filters: getFilters(state, 'applications'),
    tpStatusFilter: getFilter(state, 'applications', 't'),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  selectAll: (ids: string[]) => dispatch(selectAll('applications', ids)),
    unselectAll: (ids: string[]) => dispatch(unselectAll('applications', ids)),
    setTpStatusFilter: (selection: string[]) =>
        dispatch(setFilter('applications', 't', selection)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(ApplicationsTableHead));